import Service from "@/core/services/Service"

export default class RegularLineService extends Service {
  constructor() {
    super()
    this.routerRegularLine = "/api/lines/route"
  }

  /**
   * Fetch a line
   * @param {int} id
   */
  async getRegularLine(id) {
    let route = this.routerRegularLine + "/" + id
    this.$Progress.start()

    let info = await this.request(route)

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      return null
    }
  }

  /**
   * Create a new line
   */
  async createRegularLine(data) {
    this.$Progress.start()

    let info = await this.request(this.routerRegularLine, "post", data)

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      if (
        info.response.response.data.message === "The given data was invalid."
      ) {
        const errors = info.response.response.data.errors

        for (const property in errors) {
          switch (property) {
            case "dtfimcontrato":
              throw new Error("O campo Fim do contrato é obrigatório")
            case "dtiniciocontrato":
              throw new Error("O campo Inicio do contrato é obrigatório")
            case "dtiniciolinha":
              throw new Error("O campo Inicio da operação é obrigatório")
            case "flsituacao":
              throw new Error("O campo Ativo é obrigatório")
            case "fltoalete":
              throw new Error("O campo Toalete é obrigatório")
            case "nuservicoveiculo":
              throw new Error("O campo Serviço do veículo é obrigatório")
            case "nutransportadora":
              throw new Error("O campo Transportadora é obrigatório")
            case "tpoperacao":
              throw new Error("O campo Operação é obrigatório")
            case "tpoutorga":
              throw new Error("O campo Outorga da linha é obrigatório")
            case "tpservcompl":
              throw new Error("O campo Regime da linha é obrigatório")
            case "tpviagem":
              throw new Error("O campo Tipo de viagem é obrigatório")
            case "vlcoeficientemultiplicacao":
              throw new Error("O campo Coeficiente é obrigatório")
          }
        }
      } else {
        throw new Error("Erro ao cadastrar linha")
      }
    }
  }

  /**
   * Create new ramal
   */
  async createRamal(data) {
    this.$Progress.start()

    let info = await this.request(
      this.routerRegularLine + "/" + data.nulinharamal + "/extension",
      "post",
      data
    )

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      if (info.response.response.data.type === "validation error") {
        throw new Error(info.response.response.data.message)
      } else {
        throw new Error("Erro ao cadastrar linha")
      }
    }
  }

  /**
   * Update a line
   */
  async updateRegularLine(id, data) {
    this.$Progress.start()

    let info = await this.request(
      this.routerRegularLine + "/" + id,
      "put",
      data
    )

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      throw new Error(info.response.response.data.message)
    }
  }

  /**
   * Insert or update schedules
   */
  async insertOrUpdateSchedules(id, data) {
    this.$Progress.start()

    let info = await this.request(
      this.routerRegularLine + "/" + id + "/schedules",
      "post",
      data
    )

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      throw new Error("Erro ao atualizar horários")
    }
  }
  async insertOrUpdateSectionPoints(data, type) {
    this.$Progress.start()
    data = data.map((item) => {
      item.vlpreco = String(item.vlpreco).replace(",", ".")
      return item
    })
    let info = await this.request("/api/lines/section", type, data)

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      throw new Error("Erro ao atualizar pontos de seção")
    }
  }

  /**
   * Insere ou atualiza itinerários
   * @param {number} lineId ID da linha
   * @param {Array} itineraries Lista de itinerários
   * @returns {Promise} Promessa da requisição
   */
  async insertOrUpdateItineraries(lineId, itineraries) {
    const url = `/api/lines/${lineId}/itineraries`
    const descricao = itineraries.join(", ") // ou outro separador, se quiser
    return this.request(url, "post", { descricao })
  }
}
